import React, { useState, useEffect } from 'react';
import { getNotifications, markNotificationRead, markAllNotificationsRead } from '../services/api';
import { FiBell, FiCheck, FiCheckCircle } from 'react-icons/fi';

const TYPE_ICONS: any = { rappel: '⏰', alerte: '⚠️', objectif: '🎯', badge: '🏆', challenge: '🏁', systeme: '⚙️' };

const Notifications: React.FC = () => {
    const [notifications, setNotifications] = useState<any[]>([]);
    const [nonLues, setNonLues] = useState(0);

    const load = () => {
        getNotifications({ limit: 50 }).then(res => { setNotifications(res.data.data); setNonLues(res.data.non_lues); });
    };

    useEffect(() => { load(); }, []);

    const handleMarkRead = async (id: number) => { await markNotificationRead(id); load(); };
    const handleMarkAll = async () => { await markAllNotificationsRead(); load(); };

    return (
        <div className="page-notifications">
            <div className="page-header">
                <h2><FiBell /> Notifications ({nonLues} non lues)</h2>
                {nonLues > 0 && <button className="btn btn-secondary" onClick={handleMarkAll}><FiCheckCircle /> Tout marquer lu</button>}
            </div>
            <div className="notifications-list">
                {notifications.map(n => (
                    <div key={n.id} className={`notification-item ${n.lu ? 'read' : 'unread'}`}>
                        <span className="notif-icon">{TYPE_ICONS[n.type] || '📌'}</span>
                        <div className="notif-content">
                            <strong>{n.titre}</strong>
                            <p>{n.message}</p>
                            <small>{new Date(n.created_at).toLocaleString('fr')}</small>
                        </div>
                        {!n.lu && <button className="btn-icon" onClick={() => handleMarkRead(n.id)} title="Marquer lu"><FiCheck /></button>}
                    </div>
                ))}
                {notifications.length === 0 && <p className="text-muted">Aucune notification</p>}
            </div>
        </div>
    );
};

export default Notifications;
